import React from 'react';

import { Button } from '../../components';

import {
  availableLocales,
  useTranslate,
  useLocale,
} from '../Internationalization';

import { getLocalizedPageUrl } from '../Navigation';
import { useCurrentPage } from '../Page';

import messages from './messages';

const LanguageSelector = () => {
  const t = useTranslate(messages);
  const currentLocale = useLocale();
  const currentPage = useCurrentPage();

  const currentLocaleIndex = availableLocales.findIndex(
    locale => locale === currentLocale
  );
  const targetLocale =
    availableLocales[(currentLocaleIndex + 1) % availableLocales.length];
  const localizedPageUrl = getLocalizedPageUrl(currentPage, targetLocale);

  return (
    <Button
      padded
      className="mb-none"
      aria-label={`${t('title', targetLocale)}`}
      href={localizedPageUrl}
    >
      {targetLocale}
    </Button>
  );
};

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/modules/LanguageSelector/index.js